// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-picker{display:flex;grid-gap:20px;gap:20px}.picker{display:flex;flex-direction:column;grid-gap:10px;gap:10px}.picker__body{display:flex;grid-gap:4px;gap:4px}.picker__body .ant-select{min-width:100px;width:auto}.status{color:#f5222d}.preview{padding:5px;background:#f9f8f8;border:1px solid #e8e8e8;display:inline-block;margin-top:20px}.picker__time{margin-top:10px;line-height:50px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
